var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquaredCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 4.85221L6.99998 8.00036M6.99998 8.00036L1.33331 4.85221M6.99998 8.00036L7 14.3337M13 10.7061V5.29468C13 5.06625 13 4.95204 12.9663 4.85017C12.9366 4.76005 12.8879 4.67733 12.8236 4.60754C12.7509 4.52865 12.651 4.47318 12.4514 4.36224L7.51802 1.6215C7.32895 1.51646 7.23442 1.46395 7.1343 1.44336C7.0457 1.42513 6.95431 1.42513 6.8657 1.44336C6.76559 1.46395 6.67105 1.51646 6.48198 1.6215L1.54865 4.36225C1.34896 4.47318 1.24912 4.52865 1.17642 4.60754C1.11211 4.67733 1.06343 4.76005 1.03366 4.85017C1 4.95204 1 5.06625 1 5.29468V10.7061C1 10.9345 1 11.0487 1.03366 11.1506C1.06343 11.2407 1.11211 11.3234 1.17642 11.3932C1.24912 11.4721 1.34897 11.5276 1.54865 11.6385L6.48198 14.3793C6.67105 14.4843 6.76559 14.5368 6.8657 14.5574C6.95431 14.5756 7.0457 14.5756 7.1343 14.5574C7.23442 14.5368 7.32895 14.4843 7.51802 14.3793L12.4514 11.6385C12.651 11.5276 12.7509 11.4721 12.8236 11.3932C12.8879 11.3234 12.9366 11.2407 12.9663 11.1506C13 11.0487 13 10.9345 13 10.7061Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquaredCube);
export default __webpack_public_path__ + "static/media/squared_cube.1cf1adbb1b6e1aca4064d6f8b0b0b2fd.svg";
export { ForwardRef as ReactComponent };